"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const graphql_2 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const NewVersionInner_1 = require("./NewVersionInner");
const react_2 = require("@osmosys/react");
// interface IState {}
// const semverRegex = /\bv?(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)(?:-[\da-z-]+(?:\.[\da-z-]+)*)?(?:\+[\da-z-]+(?:\.[\da-z-]+)*)?\b/gi;
exports.NewVersion = ({ template }) => {
    // const { history } = useRouter();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.Row, null,
            react_1.default.createElement(reactstrap_1.Col, { md: {
                    offset: 2,
                    size: 8,
                } },
                react_1.default.createElement("h2", null, "Create a new version"),
                react_1.default.createElement("p", null, "A template version is a snapshot of your template's code. Use versions to keep track of changes made, or to rollback to previous versions if you need to."),
                react_1.default.createElement("hr", null))),
        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.createEmailTemplateVersion,
                refetchQueries: [
                    {
                        query: graphql_2.emailTemplateVersions,
                        variables: {
                            emailTemplateId: template.id,
                        },
                    },
                ],
            }, valuesToVariables: values => {
                return {
                    data: {
                        codePulledFrom: values.codePulledFrom,
                        emailTemplateId: template.id,
                        html: values.html,
                        releaseNotes: values.releaseNotes && values.releaseNotes.trim()
                            ? JSON.stringify({
                                blocks: [
                                    {
                                        data: {},
                                        depth: 0,
                                        entityRanges: [],
                                        inlineStyleRanges: [],
                                        key: '420vj',
                                        text: values.releaseNotes.replace(/\n/, '<br />'),
                                        type: 'unstyled',
                                    },
                                ],
                                entityMap: {},
                            })
                            : null,
                        url: values.url,
                        version: values.version,
                    },
                };
            }, formikProps: {
                initialValues: {
                    codePulledFrom: template.url ? 'templateURL' : 'pastedHTML',
                    html: '',
                    releaseNotes: '',
                    url: template.url || '',
                    version: '',
                },
                validationSchema: Yup.object().shape({
                    codePulledFrom: Yup.string()
                        .oneOf([
                        'pastedHTML',
                        'templateURL',
                        'versionURL',
                        'hostedFileURL',
                        'oceanEditor',
                    ])
                        .required('Required'),
                    html: Yup.string()
                        .when('codePulledFrom', {
                        is: val => val && val === 'pastedHTML',
                        otherwise: Yup.string(),
                        then: Yup.string().required('Required'),
                    })
                        .trim(),
                    releaseNotes: Yup.string()
                        .required('Required')
                        .trim(),
                    url: Yup.string()
                        .when('codePulledFrom', {
                        is: value => [
                            'templateURL',
                            'versionURL',
                            'hostedFileURL',
                            'oceanEditor',
                        ].includes(value),
                        otherwise: Yup.string(),
                        then: Yup.string().required('Required'),
                    })
                        .trim()
                        .url(),
                    version: Yup.string()
                        .required('Required')
                        .trim(),
                }),
            }, showBottomToolbar: true, saveButtonIcon: pro_solid_svg_icons_1.faCloudUploadAlt, saveButtonText: "Create version", showCheckIconOnSuccess: true, successMessage: () => 'Version created', renderSuccess: data => (react_1.default.createElement("div", { className: "text-center" },
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "NewVersion.open", color: "primary", osysIcon: "arrowRight", iconPosition: "right", to: `/templates/${data.createEmailTemplateVersion.template.id}/versions/${data.createEmailTemplateVersion.id}` },
                    "Open ",
                    data.createEmailTemplateVersion.version))) }, formikProps => (react_1.default.createElement(NewVersionInner_1.NewVersionInner, { formikProps: formikProps, template: template })))));
};
//# sourceMappingURL=NewVersion.js.map